const {
  required,
  requiredIf,
  between,
  maxLength,
} = require("vuelidate/lib/validators");
const getValidations = () => {
  return {
    ScheduleInterview: {
      date: { required },
      startTime: { required },
      endTime: { required },
      meetingLink: {
        required: requiredIf((obj) => !obj.withTeams && !obj.withVccl),
      },
      meetingSummary: {
        maxLength: maxLength(1024),
      },
    },

    feedbackform: {
      skills: {
        $each: {
          comments: {
            required: requiredIf((obj) => obj.commentMode && obj.mandatory),
            maxLength: maxLength(256),
          },
          mark: {
            required: requiredIf(
              (obj) => obj.markingType != "" && obj.mandatory
            ),
            between: between(1, 10),
          },
        },
      },
    },
    feedback: {
      recommendation: { required },
      recruiterRemarks: { required, maxLength: maxLength(256) },
    },

    notInterestedRemarks: {
      required,
      maxLength: maxLength(256),
    },
    remarksForChanging: { required },
    opsHeadRemarks: {
      required,
    },
    select_opsHeadName: {
      required,
    },
  };
};
module.exports = {
  getValidations,
};
